import DocumentDateInfo from './DocumentDateInfo';

export default DocumentDateInfo;
